import { useRef, useEffect } from 'react'

const EDGE_THRESHOLD = 30 // px
const TIME_WINDOW = 1000  // ms

export function useUAVisualTransition() {
  const valueRef = useRef(false)
  const edgeTouchTimestampRef = useRef(0)

  useEffect(() => {
    // Layer 1: Navigation API
    const nav = (window as any).navigation
    if (nav) {
      const handler = (event: any) => {
        valueRef.current = !!event.hasUAVisualTransition
      }
      nav.addEventListener('navigate', handler)
      return () => nav.removeEventListener('navigate', handler)
    }

    // Layer 2: 螢幕邊緣觸控啟發式（僅在不支援 Navigation API 時啟用）
    const onTouchStart = (e: TouchEvent) => {
      const touch = e.touches[0]
      if (!touch) return
      const x = touch.clientX
      const screenWidth = window.innerWidth
      if (x < EDGE_THRESHOLD || x > screenWidth - EDGE_THRESHOLD) {
        edgeTouchTimestampRef.current = Date.now()
      }
    }

    const onPopState = () => {
      const elapsed = Date.now() - edgeTouchTimestampRef.current
      if (elapsed < TIME_WINDOW) {
        valueRef.current = true
      }
    }

    window.addEventListener('touchstart', onTouchStart, { passive: true })
    window.addEventListener('popstate', onPopState)
    return () => {
      window.removeEventListener('touchstart', onTouchStart)
      window.removeEventListener('popstate', onPopState)
    }
  }, [])

  const consume = () => {
    const val = valueRef.current
    valueRef.current = false
    return val
  }

  return consume
}
